import { render, staticRenderFns } from "./project-book-project.vue?vue&type=template&id=d8ea6336&"
import script from "./project-book-project.vue?vue&type=script&lang=js&"
export * from "./project-book-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports